<template>
  <div
    v-if="isLoading !== 0 && isLoading !== false"
    :class="[
      'waiting-wrap',
      {
        'waiting-wrap__center' : center,
        'waiting-wrap__transparent' : transparent
      }
    ]"
  >
    <div
      v-if="isLoading !== -1"
      class="waiting"
      :class="transparent && 'waiting__transparent'"
    >
      <div
        class="loading"
      >
        <div class="loader">
          <span
            v-for="i in 3"
            :key="i"
            :class="transparent && 'alternative'"
          />
        </div>
      </div>
    </div>
    <div
      v-if="isLoading === -1"
      class="loading-fail"
    >
      <p class="fail-text">
        Data failed loading. Please reload.
      </p>
      <div
        class="fail-btn"
        @click="fail"
      >
        Reload
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: [Boolean, Number],
      'default': true,
    },
    center: {
      type: [Boolean],
      default: false,
    },
    transparent: {
      type: [Boolean],
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
    statement: {
      type: String,
      default: '',
    },
  },
  methods: {
    fail () {
      this.$emit('fail');
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variable.scss';
$animationTime: 0.8s;
$dotSize: 1.5rem;

@keyframes loader {
  0% {
    opacity: 0.9;
    transform: scale(0.5);
  }
  100% {
    opacity: 0.1;
    transform: scale(1);
  }
}

.waiting-wrap {
  background: $waiting-directive-background;
  &__transparent {
    background: transparent;
  }
  &__center {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.waiting {
  text-align: center;
  font-size: 12/$rem;
  color: $waiting-directive-color;
  background: $waiting-directive-background;

  &__transparent {
    background: transparent;
  }

  .loading{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    &:before{
      height: 30/$rem;
      width: 30/$rem;
      line-height: 1;
      font-size: 30/$rem;
    }
    .loader {
      text-align: center;
      span {
        background: $waiting-directive-color;

        &.alternative {
          background: $waiting-directive-color--transparent;
        }

        &:nth-of-type(2) {
          animation-delay: 0.2s;
        }
        .loader span:nth-of-type(3) {
          animation-delay: 0.2s;
        }
        display: inline-block;
        vertical-align: middle;
        width: $dotSize;
        height: $dotSize;
        border-radius: $dotSize;
        margin-right: 5px;
        animation: loader $animationTime infinite alternate;
      }
    }
  }
}
</style>
